import { AdvantageRow } from '@7chairs/types';
import { AdvantagesSectionCell } from './AdvantagesSectionCell';
import { AdvantagesSectionRowElement } from './AdvantagesSectionRow.style';

interface AdvantagesSectionRowProps {
  row: AdvantageRow;
  index: number;
  isLastRow: boolean;
}

export const AdvantagesSectionRow = (props: AdvantagesSectionRowProps) => {
  const {
    row: { cell1, cell2, cell3 },
    index,
    isLastRow,
  } = props;

  return (
    <AdvantagesSectionRowElement>
      <AdvantagesSectionCell cell={cell1} isHeader={index === 0} columnIndex={0} isCellFromLastRow={isLastRow} />
      <AdvantagesSectionCell cell={cell2} isHeader={index === 0} columnIndex={1} isCellFromLastRow={isLastRow} />
      <AdvantagesSectionCell cell={cell3} isHeader={index === 0} columnIndex={2} isCellFromLastRow={isLastRow} />
    </AdvantagesSectionRowElement>
  );
};
